<template>
  <img
    v-if="showAsCommonImage"
    :src="textStampURL(value, fillColor, outlineColor, font)"
  />
  <image
    v-else
    :width="width"
    :height="height"
    :x="x"
    :y="y"
    :xlink:href="textStampURL(value, fillColor, outlineColor, font)"
  ></image>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "TextStamp",
  props: {
    layout: {
      type: Object,
      required: true,
    },
    fieldName: {
      type: String,
      required: true,
    },
    value: {
      type: String,
    },
    fill: {
      type: Number,
    },
    outline: {
      type: Number,
    },
    font: {
      type: String,
    },
    showAsCommonImage: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters("project", [
      "getColorById",
      "projectColors",
      "isPlaybook",
      "textStampURL",
    ]),

    fillColor() {
      return this.fill
        ? this.getColorById(this.fill)?.hex
        : this.getFillColor
    },

    getFillColor() {
      return this.fieldName.indexOf('back_') === -1 
        ? this.getColorById(this.projectColors[1]?.color?.id)?.hex
        : this.getColorById(this.projectColors[0]?.color?.id)?.hex
    },

    outlineColor() {
      //todo return product color
      return this.outline
        ? this.getColorById(this.outline)?.hex
        : this.getColorById(this.projectColors[2]?.color?.id)?.hex;
    },

    width() {
      return this.layout[this.fieldName].width;
    },
    height() {
      return this.layout[this.fieldName].height;
    },
    x() {
      return this.layout[this.fieldName].x;
    },
    y() {
      return this.layout[this.fieldName].y;
    },
  },
};
</script>